<p class="cliente-form-text form-text text-muted">
    <span class="cliente-form-text-nome">
        <span>
            {{nomeFantasia}} - {{cnpjCpf}} - {{nomeCidade}} - {{uf}}
        </span>
    
        <!-- ROTA DE ENTREGA ERP - SCR -->
        <span *ngIf="rotaEntregaErpSCR">
            - ROTA DE ENTREGA: {{rotaEntregaErpSCR}}
        </span>       
    </span>

    <span class="cliente-form-text-badges">
        <span *ngIf="!config?.isCadastroCliente" class="{{cadastro | clienteCadastroBadge}}">{{cadastro | clienteCadastro}}</span>
        <span *ngIf="!config?.isSituacaoAtivo" class="{{situacao | clienteSituacaoBadge}}">{{situacao | clienteSituacao}}</span>
    </span>
</p>